// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
	const windowWidth = screen.width;

	document.addEventListener('DOMContentLoaded', () => {
		document.querySelectorAll(".btn").forEach(btn => {
			btn.classList.add("hideScroll");
		});
		document.querySelectorAll(".signup-btn").forEach(btn => {
			btn.classList.add("hideScroll");
		});
	});

	// Change value firs option iin a select
	if(document.getElementsByClassName("form-module")){
		let formModules = document.querySelectorAll(".form-module");
		formModules.forEach(form => { 
			let dropdown = form.querySelectorAll(".form-module__field.dropdown");
			dropdown.forEach(dropdownField => {
				let dropSelect = dropdownField.querySelector("select");
				let selecOption = dropSelect.querySelector("option");
				selecOption.innerText = '';
			})
		})
	}

	// Mobile Menu Functionality
	if(document.getElementById("navMenuBar")){
		let mobileContent = document.getElementById("navContainer");
		let navMobile = document.getElementById("navMenuBar");
		let menuBtn = document.querySelector("#navMenuBar [data-show_nav_m]");
		let closeBtn = document.querySelector("#navContainer [data-close_nav_m]");
		// Show
		menuBtn.addEventListener('click', function (e) {
			mobileContent.classList.add("open");
			navMobile.classList.add("menuOpen");
			document.querySelector("body").classList.add("no-scroll");
		});
		// Close
		closeBtn.addEventListener('click', function (e) {
			mobileContent.classList.remove("open");
			navMobile.classList.remove("menuOpen");
			document.querySelector("body").classList.remove("no-scroll");
		});
	}

	// Two Cards Quad height for the copy on hover
	if(document.querySelectorAll(".two-cards__item").length > 0 && windowWidth > 640){
		let cards = document.querySelectorAll(".two-cards__item");
		cards.forEach(function (card) {
			var cardContent = card.querySelector(".content");
			var cardContentHeight = cardContent.clientHeight;
			card.addEventListener('mouseenter', function () {
				cardContent.setAttribute("style", `height:${cardContentHeight}px`);
			});
			card.addEventListener('mouseleave', function () {
				cardContent.setAttribute("style", "height:0px");
			});
			cardContent.setAttribute("style", "height:0px");
		});
	}

	// Events Block
	if(document.getElementsByClassName("events-block")[0]){
		let eventsFilters = document.querySelectorAll(".events-block .filter__item .tag-js");
		for(let c = 0; c < eventsFilters.length; c++){
			eventsFilters[c].addEventListener('click', function (e) {
				e.preventDefault();

				let currentFilter = this.getAttribute("data-filter");
				document.querySelectorAll(".events-block [data-filter]").forEach(item => { item.classList.remove('active'); })
				document.querySelectorAll(`.events-block [data-filter="${currentFilter}"] `).forEach(item => { item.classList.add('active'); })
				
			});
			eventsFilters[0].click();
		}
	}

	var swiperAttractionsMap = document.querySelectorAll('.attractions-block');
    if(swiperAttractionsMap){
        swiperAttractionsMap.forEach((item)=>{
            var swiperAttractions = new Swiper('.swiper-attractionsMap', {
                /*Optional parameters*/
				autoHeight: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
				allowTouchMove: true,
				navigation: {
					nextEl: '.attractions-button-next',
					prevEl: '.attractions-button-prev',
				},
			
				// Responsive breakpoints
				breakpoints: {
					// when window width is >= 480px
					1024: {
						allowTouchMove: false
					},
				},
            });

			if(windowWidth < 640){
				let attractionsFilters = document.querySelectorAll(".attractions-block .pinsFilter__item .tag-js");
				for(let c = 0; c < attractionsFilters.length; c++){
					attractionsFilters[c].addEventListener('click', function (e) {
						swiperAttractions.destroy();
					});
				}
			}
			
			if(windowWidth > 640){
				var pins = document.getElementById('pinsAttractions').children;
				var pinHotel = document.querySelector("#pinsAttractions .pin.hotel");
	
				function mostrarContenido(index) {
					swiperAttractions.slideTo(index);
	
					for (var i = 0; i < pins.length; i++) {
						pins[i].classList.remove('show');
					}
					pins[index].classList.add('show');
				}
			
				for (var i = 0; i < pins.length; i++) {
				  pins[i].addEventListener('click', (function(index) {
					return function() {
					  mostrarContenido(index);
					};
				  })(i));
				}
				if(pinHotel){
					pinHotel.click();
				}
			}
        });
    };

	// Attractions Block
	if(document.getElementsByClassName("attractions-block")[0]){
		let attractionsFilters = document.querySelectorAll(".attractions-block .pinsFilter__item .tag-js");
		for(let c = 0; c < attractionsFilters.length; c++){
			attractionsFilters[c].addEventListener('click', function (e) {
				e.preventDefault();

				let currentFilter = this.getAttribute("data-filter");
				document.querySelectorAll(".attractions-block [data-filter]").forEach(item => { item.classList.remove('active'); })

				if(windowWidth < 640){
					document.querySelectorAll(".attractions-block [data-tag]").forEach(item => { item.classList.add('noShow'); })
				}else{
					document.querySelectorAll(".attractions-block [data-tag]").forEach(item => { item.classList.remove('active'); })
				}

				document.querySelectorAll(`.attractions-block [data-filter="${currentFilter}"] `).forEach(item => { item.classList.add('active'); })

				if(this.getAttribute("data-filter") == "all"){
					document.querySelectorAll(`.attractions-block [data-tag] `).forEach(item => { item.classList.add('active'); })
					if(windowWidth < 640){
						document.querySelectorAll(`.attractions-block [data-tag] `).forEach(item => { item.classList.remove('noShow'); })
					}
				}else{
					document.querySelectorAll(`.attractions-block [data-tag="${currentFilter}"] `).forEach(item => { item.classList.add('active'); })
					if(windowWidth < 640){
						document.querySelectorAll(`.attractions-block [data-tag="${currentFilter}"] `).forEach(item => { item.classList.remove('noShow'); })
					}
				}

				if(windowWidth < 640){
					var swiperAttractionsMap = document.querySelectorAll('.attractions-block');
					setTimeout(() => {
					if(swiperAttractionsMap){
						swiperAttractionsMap.forEach((item)=>{
							var swiperAttractions = new Swiper('.swiper-attractionsMap', {
								/*Optional parameters*/
								autoHeight: true,
								effect: "fade",
								fadeEffect: {
									"crossFade": true
								},
								allowTouchMove: true,
								navigation: {
									nextEl: '.attractions-button-next',
									prevEl: '.attractions-button-prev',
								},
							
								// Responsive breakpoints
								breakpoints: {
									// when window width is >= 480px
									1024: {
										allowTouchMove: false
									},
								},
							});
						});
					};
					}, 1500);
				}
				
			});
			attractionsFilters[0].click();
		}
	}

	// Menus
	if(document.getElementsByClassName("menu")[0]){
		let menuCategories = document.querySelectorAll(".menu .menu__tabs .js-menu-tab");
		let menusSelector = document.getElementById("menusSelector");
		let ulMenu = document.querySelector(".menu ul");
		for(let c = 0; c < menuCategories.length; c++){
			menuCategories[c].addEventListener('click', function (e) {
				e.preventDefault();

				let currentCat = this.getAttribute("data-tag");
				document.querySelectorAll(".menu [data-tag]").forEach(item => { item.classList.remove('active'); })
				document.querySelectorAll(`.menu [data-tag="${currentCat}"] `).forEach(item => { item.classList.add('active'); })

				if(menusSelector){
					menusSelector.value = currentCat;
				}
				ulMenu.classList.remove("open");

			});
			menuCategories[0].click();
		}
		if(menusSelector){
			menusSelector.addEventListener('click', (e)=>{
				e.preventDefault();
				ulMenu.classList.toggle("open");
			})
		}
	}
	// For Offers Template
	if (document.getElementById('terms_btn')) {
        let btnTerms = document.getElementById('terms_btn');
        let termsInfo = document.getElementById('terms_info');
        let termsInfoHeight = termsInfo.getElementsByClassName('wrap')[0].clientHeight;
        btnTerms.addEventListener('click', function(e) {
            e.preventDefault();
            termsInfo.classList.toggle('active');
            btnTerms.classList.toggle('active');
            if(termsInfo.classList.contains('active')){
                termsInfo.style.height = termsInfoHeight+"px";
            }else{
                termsInfo.style.height = 0+"px";
            }
        });
    }

	if(document.getElementById("intro-content")){
		// IntrotPadding
		let introContent = document.getElementById("intro-content");
		let hoursOperation = document.getElementsByClassName("hours-operation")[0];
		if(introContent.nextElementSibling == hoursOperation){
			introContent.classList.add("hoursOp");
		}
		if(document.getElementById("press")){
			// Press Button To Show Form
			let formModule = document.getElementsByClassName("form-module-wrapper")[0];
			let form = formModule.getElementsByTagName('form')[0];
			let	formId = form.getAttribute('id');
			let showBtn = document.getElementById("showForm");
				showBtn.setAttribute('href', `#${formId}`);
			if(introContent.nextElementSibling == formModule){
				showBtn.classList.remove("hidden");	
				let closeBtn = document.createElement("button");
					closeBtn.setAttribute("id", "closeForm_btn");
					closeBtn.setAttribute("aria-label", "Close Form");
					closeBtn.insertAdjacentHTML('beforeend', '<svg width="15" height="15" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1" xmlns="http://www.w3.org/2000/svg"><path d="M 0 0 L 10 10 M 10 0 L 0 10"></path></svg>');
				form.appendChild(closeBtn);

				showBtn.addEventListener('click', function() {	
					formModule.classList.add('show');
				});
				closeBtn.addEventListener('click', function(e) {	
					formModule.classList.remove('show');
					e.preventDefault();
				});
			}
		}
	}

	// Navigation
	if(window.innerWidth > 640){
		let primaryNavi = document.getElementById('primary-nav');
		let primaryNav = document.getElementById('privary-navigation');
		let firstNav = document.getElementById('firstHalft_nav');
		let lastNav = document.getElementById('lastHalft_nav');
		// Divide the Primary Nav elements
		let primaryNavLi = primaryNav.children;	
	
		let NavLiArray = Array.from(primaryNavLi);
		// console.log(NavLiArray);
		let splitNav = Math.round(NavLiArray.length / 2);
		let firstHalftElements = NavLiArray.slice(0, splitNav);
		let lastHalftElements = NavLiArray.slice(splitNav);
		
		// It add the corresponding 'li' elements 
		firstNav && firstHalftElements.forEach(element => { firstNav.append(element);} );
		lastNav && lastHalftElements.forEach(element => { lastNav.append(element); });

		primaryNavi.remove();
	}
	//
	
	document.addEventListener('DOMContentLoaded', () => {
		let btn = document.querySelectorAll('.btn, .signup-btn');
		btn.forEach(btn => {
			btn.innerHTML = `<span class="hover">${btn.innerText}</span>` + `<span class="label">${btn.innerText}</span>`;
		});

		/* Lightbox Copy */
		const customLightbox = new LBX('.js-lbx-copy', {
            customClass:'lbx-copy',
        });
		// LBX class overflow
		LBX._instances.forEach(currentItem => {
			currentItem.beforeShow = () => document.querySelector("body").classList.add("no-scroll");
			currentItem.beforeClose = () => document.querySelector("body").classList.remove("no-scroll");
		});
	})


	/* Swiper Sliders */

    let swiperTop = document.querySelectorAll('.top-content');
    if(swiperTop){
        swiperTop.forEach((item)=>{
            new Swiper('.swiper-slides', {
                /*Optional parameters*/
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true,
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },	
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				}			
            });
        });
    };
	let swiperOffers = document.querySelectorAll('.specialsList');
    if(swiperOffers){
        swiperOffers.forEach((item)=>{
            new Swiper('.swiper-offers', {
                /*Optional parameters*/
                loop: true,
				slidesPerView: 3,
      			spaceBetween: 24,
                autoplay: {
                    delay: 10000,
                    disableOnInteraction: false
                },
				navigation: {
					nextEl: '.swiper-button-next-offers',
					prevEl: '.swiper-button-prev-offers',
				},
            });
        });
    };
	let swiperEvents = document.querySelectorAll('.events-block');
    if(swiperEvents){
        swiperEvents.forEach((item)=>{
            new Swiper('.swiper-events', {
                /*Optional parameters*/
                loop: true,
				slidesPerView: 1,
      			spaceBetween: 0,
				// Responsive breakpoints
				breakpoints: {
					// when window width is >= 480px
					480: {
						slidesPerView: 3,
						spaceBetween: 40,
					},
				},
                // autoplay: {
                //     delay: 10000,
                //     disableOnInteraction: false
                // },
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
            });
        });
    };
	let swiperColumns = document.querySelectorAll('.columns-block');
    if(swiperColumns){
        swiperColumns.forEach((item)=>{
            new Swiper('.swiper-columns', {
                /*Optional parameters*/
                loop: true,
				slidesPerView: 1,
      			spaceBetween: 0,
				navigation: {
					nextEl: '.columns-button-next',
					prevEl: '.columns-button-prev',
				},
            });
        });
    };
	// let swiperSlider = document.querySelectorAll('.slider-block');
  //   if(swiperSlider){
	// 	swiperSlider.forEach( item =>{
	// 		const slideID = item.getAttribute("id");
	
	// 		let swiperImages = new Swiper(`#${slideID} .slider-block__images`, {
	// 			/*Optional parameters*/
	// 			rewind: true,
	// 			effect: "fade",
	// 			fadeEffect: {
	// 				crossFade: false,
	// 			},		
	// 			speed: 400,
	// 			slidesPerView: 1,
	// 			allowTouchMove: false
  //     });

	// 		let swiperText = new Swiper(`#${slideID}  .slider-block__text`, {
	// 			/*Optional parameters*/
	// 			rewind: true,
	// 			effect: "fade",
	// 			speed: 400,
	// 			autoHeight: false,
	// 			fadeEffect: {
	// 					crossFade: true
	// 			},
	// 			navigation: {
	// 				nextEl: `#${slideID} .swiper-button-next`,
	// 				prevEl: `#${slideID} .swiper-button-prev`,
	// 			},
	// 			allowTouchMove: true,
	// 			// Responsive breakpoints
	// 			breakpoints: {
	// 				// when window width is >= 480px
	// 				480: {
	// 					allowTouchMove: false,
	// 				},
	// 			},
  //           });
	// 					swiperText.controller.control = swiperImages
  //       });
  //   };
	let swiperGallery = document.querySelectorAll('.gallery-block');
    if(swiperGallery){
        swiperGallery.forEach((item)=>{
			new Swiper('.gallery-block__swiper', {
                /*Optional parameters*/
                loop: true,
				speed: 700,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				navigation: {
					nextEl: '.gal-button-next',
					prevEl: '.gal-button-prev',
				},
				initialSlide: 0,
				allowTouchMove: false
            });
			new Swiper('.gallery-block__swiper2', {
                /*Optional parameters*/
                loop: true,
				speed: 700,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				navigation: {
					nextEl: '.gal-button-next',
					prevEl: '.gal-button-prev',
				},
				initialSlide: 1,
				allowTouchMove: false
            });
			new Swiper('.gallery-block__swiper3', {
                /*Optional parameters*/
                loop: true,
				speed: 700,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				navigation: {
					nextEl: '.gal-button-next',
					prevEl: '.gal-button-prev',
				},
				initialSlide: 2,
				allowTouchMove: false
            });
        });
    };
	var swiperHotelMap = document.querySelectorAll('.hotel-map');
    if(swiperHotelMap){
        swiperHotelMap.forEach((item)=>{
            var swiperHotel = new Swiper('.swiper-hotelMap', {
                /*Optional parameters*/
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
				allowTouchMove: false
            });
			var pins = document.getElementById('pins').children;

			function mostrarContenido(index) {
				swiperHotel.slideTo(index);

				for (var i = 0; i < pins.length; i++) {
					pins[i].classList.remove('active');
				}
				pins[index].classList.add('active');
			}
		
			for (var i = 0; i < pins.length; i++) {
			  pins[i].addEventListener('click', (function(index) {
				return function() {
				  mostrarContenido(index);
				};
			  })(i));
			  pins[0].click();
			}
        });
    };


    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}